import React, { useEffect, useState } from "react";
import { userAtom, tokenAtom } from "../global/globalState";
import { useRecoilValue } from "recoil";
import Axios from "axios";

const Dashboard = ({ history }) => {
	const token = useRecoilValue(tokenAtom);
	const student = useRecoilValue(userAtom);
	const [notices, setNotices] = useState(null);

	useEffect(() => {
		Axios.get(`${process.env.REACT_APP_API_URL}/student/getNotices`, {
			headers: {
				Authorization: "Bearer " + token,
			},
		}).then((res) => {
			setNotices(res.data.response.notices);
			console.log(res.data.response.notices);
		});
	}, []);

	return (
		<div className="Dashboard">
			<div className="container">
				<div className="main">
					<div className="assignments">
						<div className="title">Assignments</div>
						<div className="assignment-cards">
							{student.assignments &&
								student.assignments.map(
									({ assignmentDetails, _id }) => (
										<div
											key={_id}
											onClick={() =>
												history.push(
													`/dashboard/assignment/${_id}`
												)
											}
											className="assignment-card">
											<img
												src="https://via.placeholder.com/150"
												alt="Placeholder"
											/>
											<h3 className="assignment-heading">
												{assignmentDetails.description}
											</h3>
											<p>
												<strong>File : </strong>
												<a
													href={
														assignmentDetails.assignmentGiven
													}>
													{assignmentDetails.assignmentGiven.substring(
														68
													)}
												</a>
											</p>
											<div className="given-by">
												Given By :{" "}
												{assignmentDetails.givenBy}
											</div>
										</div>
									)
								)}
						</div>
					</div>
					<div className="notices">
						<div className="title">Notices</div>
						<div className="notice-cards">
							{notices &&
								notices.map(
									({ description, title, noticeBy, _id }) => (
										<div key={_id} className="notice-card">
											<div className="notice-card-title">
												{title}
											</div>
											<p className="notice-card-details">
												{description}
											</p>
											<div className="notice-card-author">
												By - {noticeBy.name}
											</div>
										</div>
									)
								)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
